import React from "react";



const MaintenancePeople = () => {

return(


    <>
    </>
)




}

export {MaintenancePeople}